import { FeatureFlagsConfig } from "./models/feature-flag.model";

export const featuresConfig: FeatureFlagsConfig = {
  openAIIntegration: "LIVE",
  reviewSystem: "LIVE",
  analyticsEngagement: "DEVELOPMENT",
  aiStudentAssistantSetting: "LIVE",
  aiStudentAssistantChat: "LIVE",
  stripeTaxIntegration: "LIVE",
  ochApiIntegration: "DEVELOPMENT",
  emailTemplate: "LIVE",
  stripeMultiplePaymentMethods: "LIVE",
  courseAiThumbnailGenerator: "LIVE",
  courseAiTitleGenerator: "LIVE",
  scormUpload: "LIVE",
  onBoardingTutorials: "LIVE",
  videoTutorials: "LIVE",
  studentDetailEnrollmentTab: "QA-TEST",
};
